import GameModel from "../../model/GameModel";
import { ICondition } from "../State";
import RealityCheckModel from "../../model/RealityCheckModel";

export class HasRealityCheckCondition implements ICondition {
  public check(): boolean {
    return GameModel.hasRealityCheck && RealityCheckModel.performRealityCheck();
  }
}

export class ForceRealityCheckCondition implements ICondition {
  public check(): boolean {
    if (GameModel.forceRealityCheck) {
      GameModel.forceRealityCheck = false;
      return RealityCheckModel.performRealityCheck();
    } else {
      return false;
    }
  }
}
